/*
  ref
  https://yami.io/jwt/
  https://vuex.vuejs.org/zh/guide/
  https://github.com/js-cookie/js-cookie
*/
import Cookies from 'vue-cookies'

// actions
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
// mutations
export const LOAD = 'LOAD'
export const UPDATE_AUTH = 'UPDATE_AUTH'
export const UPDATE_USERNAME = 'UPDATE_NAME'
export const UPDATE_IMAGEINFO = 'UPDATE_IMAGEINFO'
// getters
export const USER_ID = 'USER_ID'
export const IS_LOGIN = 'IS_LOGIN'
export const WITH_CUSTOMER_ROLE = 'WITH_CUSTOMER_ROLE'
export const WITH_RESTAURANT_ROLE = 'WITH_RESTAURANT_ROLE'
export const WITH_ADMIN_ROLE = 'WITH_ADMIN_ROLE'
export const WITH_ROLE = 'WITH_ROLE'

const state = {
  token: null,
  roles: null,
  expiry: null,
  id: null,
  name: null,
  image: null
}
const actions = {
  [LOGIN] ({ commit }, data) {
    commit(UPDATE_AUTH, data)
    commit(UPDATE_USERNAME, data.name)
    commit(UPDATE_IMAGEINFO, data.image)
  },
  [LOGOUT] ({ commit }) {
    commit(UPDATE_AUTH, null)
    commit(UPDATE_USERNAME, null)
    commit(UPDATE_IMAGEINFO, null)
  }
}
const mutations = {
  [LOAD] () {
    let _roles = Cookies.get('roles')
    if (_roles) {
      state.roles = _roles.split(',')
    }
    state.token = Cookies.get('token')
    state.id = Cookies.get('id')
    state.expiry = Cookies.get('expiry')
    state.name = Cookies.get('name')
    state.imgInfo = Cookies.get('image')
  },
  [UPDATE_AUTH] (state, data) {
    if (data && data.token) {
      let _expiry = new Date(data.expiry)
      state.token = data.token
      state.roles = data.roles
      state.id = data.id
      state.expiry = _expiry.getTime()
      Cookies.set('token', data.token, _expiry)
      Cookies.set('roles', data.roles, _expiry)
      Cookies.set('id', data.id, _expiry)
      Cookies.set('expiry', _expiry.getTime(), _expiry)
    } else {
      state.token = null
      state.roles = null
      state.id = null
      state.expiry = null
      Cookies.remove('token')
      Cookies.remove('roles')
      Cookies.remove('id')
      Cookies.remove('expiry')
    }
  },
  [UPDATE_USERNAME] (state, name) {
    state.name = name
    Cookies.set('name', name, 0)
  },
  [UPDATE_IMAGEINFO] (state, image) {
    state.imgInfo = image
    Cookies.set('imgInfo', image, 0)
  }
}

const getters = {
  [USER_ID] (state) {
    return state.id
  },
  [IS_LOGIN] (state) {
    return !!state.token
  },
  [WITH_CUSTOMER_ROLE] (state) {
    return state.roles ? state.roles.some(r => r === 'Customer') : false
  },
  [WITH_RESTAURANT_ROLE] (state) {
    return state.roles ? state.roles.some(r => r === 'Restaurant') : false
  },
  [WITH_ADMIN_ROLE] (state) {
    return state.roles ? state.roles.some(r => r === 'Admin') : false
  },
  [WITH_ROLE]: (state, value) => (role) => {
    return state.roles ? state.roles.some(r => r === role) : false
  }
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true // 多模組的時候，當有相同名稱的變數或方法才能區隔開
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js